export const DEFAULT_SEGMENT_NAME_TEXT = 'Segment name must be between 1 to 64 characters';
export const ERROR_SEGMENT_NAME_TEXT =
  'Segment name cannot be blank. Please provide a valid segment name';

export const DEFAULT_S3_URL_TEXT = 'Provide the S3 URL of the .csv file';
export const ERROR_S3_URL_TEXT = 'Invalid S3 URL. Please provide a valid S3 URL';
export const SOMETHING_WENT_WRONG = 'Something went wrong. Please try again after sometime';
export const CSV_TEMPLATE_HEADERS = 'ChannelType,Address,Attributes.Alias\r';
export const PARENTEX_CSV_TEMPLATE_HEADERS = 'Run_Date,Employee,Manager,Template,Employee_First_Name,Manager_First_Name\r';
export const ADDRESS_COLUMN_INFO = `The unique destination address for messages or push notifications that
you send to the endpoint—for example, an email address`;

export const CHANNEL_TYPE_INFO = `The channel to use when sending messages or push notifications to the
endpoint. For example:`;

export const FROM_ADDRESS_FOOTER_TEXT =
  'Email address of the sender. Please enter in the format "name"<email>';
export const FROM_ADDRESS_FOOTER_ERROR_TEXT = 'Invalid email address. Please use a valid email';
export const TEST_EMAIL_TOOLTIP_TEXT =
  'Send a test email to check the template before actually sending the nudge';
export const CHANNEL_TYPE_TOOLTIP_TEXT = 'Channel type is the mode of communication channel.';

export const SESSION_TIMED_OUT = 'Session timed out. Please refresh the page and login again.';

export const SEGMENT_DOWNLOAD_SUCCESS = 'Segment downloaded successfully.';
export const FAILED_SEGMENT_DOWNLOAD = 'Failed to download segment data. Please try again later.';

export const SUCCESS_CAMPAIGN_DELETE = 'Campaign deleted successfully';
export const FAILED_CAMPAIGN_DELETE = 'Failed to delete campaign. Please try again in sometime.';

export const SUCCESS_CAMPAIGN_CREATION = 'Campaign created successfully';
export const FAILED_CAMPAIGN_CREATION = 'Failed to create campaign. Please try again later';

export const IMAGE_UPLOAD_SUCCESS = 'Image uploaded successfully.';
export const IMAGE_UPLOAD_ERROR = 'Image upload failed. Please try again later.';

export const TEMPLATE_CREATE_SUCCESS = 'Template created successfully successfully';
export const TEMPLATE_CREATE_ERROR = 'Failed to create template. Please try again in sometime';
export const TEMPLATE_UPDATE_SUCCESS = 'Template updated successfully';
export const TEMPLATE_UPDATE_ERROR = 'Failed to update template. Please try again in sometime';
export const TEMPLATE_DELETE_SUCCESS = 'Template deleted successfully';
export const TEMPLATE_DELETE_ERROR = 'Failed to delete template. Please try again in sometime';

export const INVALID_TEMPLATE_NAME_MESSAGE =
  'Template name cannot be blank. Please enter a valid single word template name without spaces';

export const DUPLICATE_TEMPLATE_NAME_MESSAGE =
  'Template name already exists. Please use a different name and try again.';
export const MULTI_WORD_TEMPLATE_NAME_MESSAGE =
  'Template name cannot have multiple words. Please use a single word template name.';

export const SEGMENT_UPDATE_SUCCESSFUL =
  'Segment update request submitted successfully. We will notify you via an email once the segment update is complete.';
export const SEGMENT_UPDATE_FAILED = 'Failed to update segment. Please try again after sometime';

export const PARENTEX_NUDGE_NAME = 'ParentEx nudge name must be between 1 to 64 characters';
export const PARENTEX_SUCESS = "ParentEx nudge creation request successfully submitted. This process may take few mins to complete please check back in sometime";
export const PARENTEX_FAILURE = "Something went wrong. Please try again later";
